import { latestSchemaVersion } from '../schema/flameSchema'
import { defineExample, tid, vid } from './util'

/**
 * Aurora Borealis — northern lights curtain effect.
 * sinusoidal3D + polar3D for flowing vertical curtains,
 * handkerchief3D for organic wave patterns, and
 * linear3D for structure.
 */
export const example41 = defineExample({
  version: latestSchemaVersion,
  metadata: {
    author: 'unknown',
    name: 'Aurora Borealis',
    description:
      'northern lights curtain effect. sinusoidal3D + polar3D for flowing vertical curtains, handkerchief3D for organic wave patterns, and linear3D for structure.',
  },
  renderSettings: {
    dimensions: 3,
    exposure: -1.6,
    skipIters: 18,
    drawMode: 'light',
    colorInitMode: 'colorInitZero',
    pointInitMode: 'pointInitUnitSphere',
    vibrancy: 1.6,
    contrast: 2.8,
    gamma: 2.8,
    depthColorPower: 0.0,
    lightDirection: [0, -0.5, -1],
    lightPower: 0.1,
    highlightPower: 0.7,
    densityEstimationQuality: 0.75,
    estimatorCurve: 0.5,
    paletteMode: 0,
    palettePhase: 0.35,
    paletteSpeed: 0.5,
    camera: { zoom: 1, position: [0, 0] },
    camera3D: {
      theta: 2.1720004272460964,
      phi: 1.1519999694824232,
      radius: 1.19614492935718,
      target: [0, 0, 0],
      fov: 50,
    },
  },
  transforms: {
    [tid('3d_aurora_a')]: {
      probability: 0.4,
      preAffine: {
        a: 0.9,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0.3,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0.9,
        l: 0,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.05, y: 0.4 },
      colorSpeed: 0.4,
      variations: {
        [vid('3d_aurora_a_v0')]: { type: 'sinusoidal3D', weight: 0.7 },
        [vid('3d_aurora_a_v1')]: { type: 'handkerchief3D', weight: 0.4 },
      },
    },
    [tid('3d_aurora_b')]: {
      probability: 0.35,
      preAffine: {
        a: 0.8,
        b: 0.15,
        c: 0,
        d: 0,
        e: -0.15,
        f: 0.8,
        g: 0,
        h: 0.2,
        i: 0,
        j: 0,
        k: 0.7,
        l: 0,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: -0.2, y: 0.15 },
      colorSpeed: 0.35,
      variations: {
        [vid('3d_aurora_b_v0')]: { type: 'polar3D', weight: 0.6 },
        [vid('3d_aurora_b_v1')]: { type: 'linear3D', weight: 0.5 },
      },
    },
    [tid('3d_aurora_c')]: {
      probability: 0.25,
      preAffine: {
        a: 0.7,
        b: 0,
        c: 0.1,
        d: 0,
        e: 0,
        f: 0.7,
        g: 0,
        h: 0,
        i: -0.1,
        j: 0,
        k: 0.5,
        l: 0.1,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.3, y: -0.2 },
      colorSpeed: 0.3,
      variations: {
        [vid('3d_aurora_c_v0')]: { type: 'curl3D', weight: 0.5 },
        [vid('3d_aurora_c_v1')]: { type: 'sinusoidal3D', weight: 0.4 },
      },
    },
  },
})
